/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_ApprovalsInputs */

const en_portal_nav_approvals = /** @type {(inputs: Portal_Nav_ApprovalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvals`)
};

/** @type {(inputs: Portal_Nav_ApprovalsInputs) => LocalizedString} */
const ar_portal_nav_approvals = en_portal_nav_approvals;

/** @type {(inputs: Portal_Nav_ApprovalsInputs) => LocalizedString} */
const he_portal_nav_approvals = en_portal_nav_approvals;

/** @type {(inputs: Portal_Nav_ApprovalsInputs) => LocalizedString} */
const ur_portal_nav_approvals = en_portal_nav_approvals;

/** @type {(inputs: Portal_Nav_ApprovalsInputs) => LocalizedString} */
const es_portal_nav_approvals = en_portal_nav_approvals;

/** @type {(inputs: Portal_Nav_ApprovalsInputs) => LocalizedString} */
const fr_portal_nav_approvals = en_portal_nav_approvals;

/** @type {(inputs: Portal_Nav_ApprovalsInputs) => LocalizedString} */
const de_portal_nav_approvals = en_portal_nav_approvals;

/** @type {(inputs: Portal_Nav_ApprovalsInputs) => LocalizedString} */
const pt_portal_nav_approvals = en_portal_nav_approvals;

/** @type {(inputs: Portal_Nav_ApprovalsInputs) => LocalizedString} */
const hi_portal_nav_approvals = en_portal_nav_approvals;

/** @type {(inputs: Portal_Nav_ApprovalsInputs) => LocalizedString} */
const bn_portal_nav_approvals = en_portal_nav_approvals;

/**
* | output |
* | --- |
* | "Approvals" |
*
* @param {Portal_Nav_ApprovalsInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_nav_approvals = /** @type {((inputs?: Portal_Nav_ApprovalsInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_ApprovalsInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_nav_approvals(inputs)
	if (locale === "he") return he_portal_nav_approvals(inputs)
	if (locale === "ur") return ur_portal_nav_approvals(inputs)
	if (locale === "es") return es_portal_nav_approvals(inputs)
	if (locale === "fr") return fr_portal_nav_approvals(inputs)
	if (locale === "de") return de_portal_nav_approvals(inputs)
	if (locale === "pt") return pt_portal_nav_approvals(inputs)
	if (locale === "hi") return hi_portal_nav_approvals(inputs)
	if (locale === "bn") return bn_portal_nav_approvals(inputs)
	return /** @type {LocalizedString} */ ("Approvals")
});